import { render, staticRenderFns } from "./ScimToken.vue?vue&type=template&id=631e668a&"
import script from "./ScimToken.vue?vue&type=script&lang=js&"
export * from "./ScimToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports